/*
 * sfc-gallery-browse.js — Oct 12 2026
 *
 * Danny: "i want to scroll through the colors without clicking each color".
 * On opted-in products (handle list in snippets/media-gallery.liquid) the main
 * product image becomes a colour browser: swipe it (mobile / trackpad), use the
 * arrows, or the keyboard arrows, and every photo you land on SELECTS that
 * colour — price, SKU, Add to cart and URL all follow.
 *
 * Oct 12 2026 (later): extended to every product whose FIRST option is
 * Type / Color / Colour (the flake blends, micas, glitter, quartz). The gate
 * lives in snippets/media-gallery.liquid.
 *
 * How it works, outside-in (no theme JS is modified):
 *  - Liquid emits every variant's featured media + options as
 *    application/vnd.sfc-browse+json. NOT application/json — variant-picker.js
 *    takes the first application/json it finds as the current variant.
 *  - The gallery is filtered to one photo per colour for the CURRENT other
 *    options (Grade 40-S vs 25-A on quartz) and reordered to match the colour
 *    buttons, so swipe order == button order. Everything else is display:none.
 *  - When a swipe/arrow scroll settles on a photo whose colour is not selected,
 *    the colour input is checked and a change event fired with noFocus — the
 *    same path the theme's own applySearchParams() uses. noFocus matters: the
 *    theme otherwise focuses the picker input, which scrolls the page away
 *    from the image mid-swipe on a phone.
 *  - on:variant:change re-filters (grade change) and re-aligns the slider.
 */
(function () {
  'use strict';
  if (window.__sfcGalleryBrowse) return;
  window.__sfcGalleryBrowse = true;

  var dataEl = document.querySelector('script[data-sfc-browse]');
  if (!dataEl) return;
  var VARIANTS;
  try { VARIANTS = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!VARIANTS || VARIANTS.length < 2) return;

  var BROWSE = 0; // option position 1 = the colour option
  var section = dataEl.closest('.shopify-section') || document;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var gallery = null;
  var ui = null;
  var items = [];
  var current = -1;
  var signature = null;
  var suppressUntil = 0;
  var pending = false;
  var pendingTimer = null;
  var settleTimer = null;
  var bound = typeof WeakSet === 'function' ? new WeakSet() : null;

  function now() { return Date.now(); }
  function suppress(ms) { suppressUntil = now() + ms; }
  function picker() { return section.querySelector('variant-picker'); }
  function selectorFor(pos) {
    var p = picker();
    return p ? p.querySelector('.option-selector[data-index="' + pos + '"]') : null;
  }

  function selectedOptions() {
    var p = picker();
    if (!p) return null;
    var out = [];
    p.querySelectorAll('.option-selector').forEach(function (sel) {
      var idx = parseInt(sel.dataset.index, 10) - 1;
      var c = sel.querySelector('input.js-option:checked');
      out[idx] = c ? c.value : null;
    });
    return out;
  }

  /* Colour values in button order, skipping any the theme hides. */
  function browsableValues() {
    var sel = selectorFor(BROWSE + 1);
    if (!sel) return [];
    var out = [];
    sel.querySelectorAll('input.js-option').forEach(function (i) {
      if (i.classList.contains('sfc-variant-hidden') || i.classList.contains('sfc-variant-absent')) return;
      out.push(i.value);
    });
    return out;
  }

  function otherSignature(sel) {
    return sel.filter(function (v, i) { return i !== BROWSE; }).join('|');
  }

  /*
   * Which variant a colour selects, given the other options now chosen:
   * the exact match if it exists and is not flagged custom.hidden, else the
   * first visible variant of that colour. NEVER a hidden variant — on the
   * blends the hidden 1/4" duplicates are a double-ship risk.
   */
  function targetsFor(sel) {
    var exact = {};
    var any = {};
    var media = {};
    VARIANTS.forEach(function (v) {
      if (!v.o) return;
      var c = v.o[BROWSE];
      if (v.m && !media[c]) media[c] = String(v.m);
      if (v.h) return;
      if (!any[c]) any[c] = v;
      if (exact[c]) return;
      for (var i = 0; i < v.o.length; i += 1) {
        if (i !== BROWSE && sel[i] != null && v.o[i] !== sel[i]) return;
      }
      exact[c] = v;
    });
    return { exact: exact, any: any, media: media };
  }

  function build() {
    var sel = selectedOptions();
    if (!sel) return false;
    var viewer = gallery.querySelector('.media-viewer');
    if (!viewer) return false;

    var t = targetsFor(sel);
    var all = Array.prototype.slice.call(viewer.querySelectorAll('.media-viewer__item'));
    var byId = {};
    all.forEach(function (li) { byId[li.dataset.mediaId] = li; });

    // Every photo tied to ANY variant. Unused ones are other sizes/grades and
    // get hidden; photos tied to no variant (lifestyle shots) stay, at the end.
    var variantMedia = {};
    VARIANTS.forEach(function (v) { if (v.m) variantMedia[String(v.m)] = true; });

    var next = [];
    var used = {};
    browsableValues().forEach(function (val) {
      var v = t.exact[val] || t.any[val];
      if (!v) return;
      var id = v.m ? String(v.m) : t.media[val];
      var li = id && byId[id];
      if (li && !used[id]) {
        used[id] = true;
        next.push({ value: val, li: li, variant: v });
      }
    });
    if (next.length < 2) return false;

    suppress(600);
    next.forEach(function (it) {
      it.li.style.display = '';
      it.li.classList.remove('media-viewer__item--single');
      viewer.appendChild(it.li);
    });
    all.forEach(function (li) {
      var id = li.dataset.mediaId;
      if (used[id]) return;
      if (variantMedia[id]) {
        li.style.display = 'none';
      } else {
        li.style.display = '';
      }
      viewer.appendChild(li);
    });

    items = next;
    signature = otherSignature(sel);
    gallery.setVisibleItems();
    if (gallery.visibleItems && gallery.visibleItems.length > 1) {
      gallery.viewerItemOffset = gallery.visibleItems[1].offsetLeft - gallery.visibleItems[0].offsetLeft;
    }
    return true;
  }

  function indexOfSelected() {
    var sel = selectedOptions();
    var v = sel && sel[BROWSE];
    for (var i = 0; i < items.length; i += 1) {
      if (items[i].value === v) return i;
    }
    return -1;
  }

  function syncToSelection() {
    if (!items.length) return;
    var i = indexOfSelected();
    if (i < 0) i = 0;
    suppress(500);
    gallery.currentItem = null; // customSetActiveMedia() returns early on the same item
    gallery.customSetActiveMedia(items[i].li, true);
    current = i;
    updateUi();
  }

  function scrollIndex() {
    var viewer = gallery.viewer;
    var off = gallery.viewerItemOffset || viewer.clientWidth || 1;
    var i = Math.round(viewer.scrollLeft / off);
    var max = (gallery.visibleItems ? gallery.visibleItems.length : items.length) - 1;
    return Math.max(0, Math.min(max, i));
  }

  function updateUi() {
    if (!ui) return;
    var tag = ui.querySelector('.sfc-browse__tag');
    if (!items[current]) {
      tag.style.visibility = 'hidden'; // on a non-colour photo
      return;
    }
    tag.style.visibility = '';
    ui.querySelector('.sfc-browse__name').textContent = items[current].value;
    ui.querySelector('.sfc-browse__count').textContent = (current + 1) + ' of ' + items.length;
  }

  /*
   * Select a colour. Checks every option of the target variant, then fires ONE
   * change event from the fieldset (not an input) with detail.variantId —
   * variant-picker.js prefers evt.target.dataset.variantId, and a colour
   * input's id is only right if no other option has to move with it.
   */
  function choose(it) {
    var p = picker();
    if (!p || !it || !it.variant) return;
    var v = it.variant;
    var fieldset = null;
    for (var i = 0; i < v.o.length; i += 1) {
      var s = selectorFor(i + 1);
      if (!s) continue;
      var input = null;
      s.querySelectorAll('input.js-option').forEach(function (x) {
        if (!input && x.value === v.o[i]) input = x;
      });
      if (!input) return;
      input.checked = true;
      if (i === BROWSE) fieldset = s;
    }
    if (!fieldset) return;
    pending = true;
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function () { pending = false; }, 4000);
    fieldset.dispatchEvent(new CustomEvent('change', {
      bubbles: true,
      cancelable: false,
      detail: { noFocus: true, variantId: String(v.i) }
    }));
  }

  function onSettle() {
    if (now() < suppressUntil || pending) {
      settleTimer = setTimeout(onSettle, 200);
      return;
    }
    var it = items[scrollIndex()];
    if (!it) return; // a non-colour photo selects nothing
    var sel = selectedOptions();
    if (sel && sel[BROWSE] === it.value) return;
    choose(it);
  }

  function onScroll() {
    if (!items.length) return;
    var i = scrollIndex();
    if (i !== current) {
      current = i;
      updateUi();
    }
    clearTimeout(settleTimer);
    settleTimer = setTimeout(onSettle, 180);
  }

  function step(dir) {
    if (!items.length) return;
    var from = current < 0 ? scrollIndex() : current;
    if (from >= items.length) from = items.length; // on a non-colour photo
    var to = from + dir;
    var wrap = false;
    if (to < 0) { to = items.length - 1; wrap = true; }
    if (to >= items.length) { to = 0; wrap = true; }
    gallery.viewer.scrollTo({
      left: items[to].li.offsetLeft,
      behavior: wrap || reduceMotion ? 'auto' : 'smooth'
    });
  }

  var ICON_PREV = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>';
  var ICON_NEXT = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>';

  function mountUi() {
    var host = gallery.querySelector('.media-gallery__viewer');
    if (!host) return;
    ui = host.querySelector('.sfc-browse');
    if (ui) return;
    ui = document.createElement('div');
    ui.className = 'sfc-browse';
    ui.innerHTML =
      '<button type="button" class="sfc-browse__btn sfc-browse__btn--prev" aria-label="Previous colour">' + ICON_PREV + '</button>' +
      '<button type="button" class="sfc-browse__btn sfc-browse__btn--next" aria-label="Next colour">' + ICON_NEXT + '</button>' +
      '<div class="sfc-browse__tag" aria-hidden="true"><span class="sfc-browse__name"></span><span class="sfc-browse__count"></span></div>';
    host.appendChild(ui);
    ui.querySelector('.sfc-browse__btn--prev').addEventListener('click', function (e) { e.preventDefault(); step(-1); });
    ui.querySelector('.sfc-browse__btn--next').addEventListener('click', function (e) { e.preventDefault(); step(1); });
  }

  function bindGallery() {
    if (bound && bound.has(gallery)) return;
    if (bound) bound.add(gallery);
    gallery.viewer.addEventListener('scroll', onScroll, { passive: true });
    gallery.viewer.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    });
  }

  function ensureGallery() {
    var g = section.querySelector('media-gallery');
    if (!g || g.dataset.layout !== 'slider' || !g.viewer || !g.visibleItems) return false;
    if (g !== gallery) {
      gallery = g;
      ui = null;
      signature = null;
    }
    bindGallery();
    mountUi();
    return true;
  }

  function refresh(force) {
    if (!ensureGallery()) return;
    var sel = selectedOptions();
    if (!sel) return;
    if (force || otherSignature(sel) !== signature || !items.length) {
      if (!build()) {
        if (ui) ui.style.display = 'none';
        return;
      }
      if (ui) ui.style.display = '';
    }
    syncToSelection();
  }

  section.addEventListener('on:variant:change', function () {
    pending = false;
    clearTimeout(pendingTimer);
    // Let media-gallery's own listener run first, then correct for filtering.
    setTimeout(function () { refresh(false); }, 30);
  });

  function start() {
    var tries = 0;
    (function wait() {
      var g = section.querySelector('media-gallery');
      if (g && g.viewer && g.visibleItems) {
        refresh(true);
        return;
      }
      tries += 1;
      if (tries < 40) setTimeout(wait, 100);
    })();
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('media-gallery').then(function () { setTimeout(start, 50); });
  } else {
    window.addEventListener('load', start);
  }
})();
